import { JobEntityModel } from "src/store/models/entity/job/entity";
import { JobHelperModel } from "src/store/models/entity/job/helper";

export const encooJobModels = {
  entity: JobEntityModel,
  helper: JobHelperModel,
};
